import React from 'react';
import styled, { css } from 'styled-components';
import RichtextParser from '../../utils/richtext-parser';
import Container from '../container';
import ContentCardGridItem from './ContentCardGridItem';
import mq from '../../utils/mq';

const OuterContainer = styled.div<{ $theme?: 'white' | 'grey' }>`
  background-color: ${({ $theme }) =>
    $theme === 'white' ? '#fff' : '#f8f8f8'};
  padding: 94px 0;
  ${mq.mobile(css`
    padding: 64px 0;
  `)};
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  text-align: center;
  padding-bottom: 65px;
  max-width: 720px;
  margin: 0 auto;
  ${mq.mobile(css`
    padding-bottom: 32px;
    max-width: unset;
    text-align: left;
    align-items: flex-start;
    gap: 16px;
  `)};
`;

const Title = styled.h2`
  color: #161616;
  font-size: 42px;
  font-style: normal;
  font-weight: 700;
  line-height: 115%;
  letter-spacing: -0.84px;
  text-align: inherit;
  ${mq.mobile(css`
    font-size: 36px;
  `)};
`;

const Description = styled.div`
  color: #666;
  text-wrap: pretty;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.36px;
  text-align: inherit;
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  ${mq.tablet(css`
    grid-template-columns: repeat(2, 1fr);
  `)};
  ${mq.mobile(css`
    grid-template-columns: repeat(1, 1fr);
  `)};
`;

export default function ContentCardGrid({
  title,
  description,
  theme,
  cards
}: {
  title: string;
  description: any;
  theme?: 'white' | 'grey';
  cards: any[];
}) {
  return (
    <OuterContainer $theme={theme}>
      <Container>
        <TitleSection>
          <Title>{title}</Title>
          <Description
            dangerouslySetInnerHTML={{ __html: RichtextParser(description) }}
          />
        </TitleSection>
        <CardsContainer>
          {cards.map((card) => (
            <ContentCardGridItem key={card.id} {...card} theme={theme} />
          ))}
        </CardsContainer>
      </Container>
    </OuterContainer>
  );
}
